import React from 'react';
import getBaseTitle from './getBaseTitle';

const getComplexArrayValueTitle = (confirmedData) => {
  if ((!confirmedData?.value && !confirmedData.excludedValues) || !confirmedData?.operator) return '';
  let firstValue = '';
  let isSingleValue = false;
  let valueCount = 0;
  let text = [];

  if (confirmedData.value && confirmedData.value.length > 0) {
    [firstValue] = confirmedData.value;
    isSingleValue = confirmedData.value.length === 1;
    valueCount = confirmedData.value.length;
    text = confirmedData.value;
  } else {
    [firstValue] = confirmedData.excludedValues;
    isSingleValue = confirmedData.excludedValues.length === 1;
    valueCount = confirmedData.excludedValues.length;
    text = confirmedData.excludedValues;
  }
  const getValueText = (item) => item?.name || item?.title || item?.displayName || item;

  if (valueCount > 1) {
    return (
      <>
        <span className="searchFilterItem__subtitle">
          {getBaseTitle({
            text: getValueText(firstValue),
            operator: confirmedData.operator,
            isSingle: isSingleValue,
          })}
        </span>
        &nbsp;
        {(confirmedData.operator === 'oneOfExceptAllOf' || confirmedData.operator === 'oneOfExceptOneOf') && 'or'}
        {(confirmedData.operator === 'allOfExceptAllOf' || confirmedData.operator === 'allOfExceptOneOf') && 'and'}
        &nbsp;
        <span>{`+${valueCount - 1}`}</span>
      </>
    );
  }

  return (
    <span className="searchFilterItem__subtitle">
      {getBaseTitle({
        text: text.map(getValueText).join(', '),
        operator: confirmedData.operator,
        isSingle: isSingleValue,
      })}
    </span>
  );
};

export default getComplexArrayValueTitle;
